const csvFile = `"Last Name","First Name","Gender","Sender MRN","Source MRN","Date of Birth","Event Time","Alert Type","Hospital Service","Admit Source","Admit Date","Patient Complaints","Diagnosis Code","Diagnosis Desc","Observation Status","Abdominal Pain","Discharge Date","Discharge Location","Discharge Disposition","Death Indicator"
"""Jackson""","""Emily""","Female","fYBinwjhD0","aTYfmpfzpu","01/05/1986","12/20/2020, 11:21 am","ADT Notification","Service A","","12/19/2020","","309","","","none","12/20/2020, 1:02 pm","Home","",""`;

export default function downloadExportedFileMock({ resolve }) {
	setTimeout(() => {
		resolve(csvFile);
	}, 1000);
}
